import React, { useState, useEffect } from 'react';
import {
  TextField, Button, Paper, Typography, Box, Snackbar, Alert,
  FormControl, InputLabel, Select, MenuItem
} from '@mui/material';
import { updateCategoryGroup } from '../../../../services/menuPage';
import { fetchKitchens, fetchActiveBranches } from '../../../../services/dashboard/apiServiceDashboard';

const EditCategoryGroupForm = ({ initialData, onSuccess }) => {
  const [formData, setFormData] = useState({
    id: initialData.id || '',
    name: initialData.name || '',
    kitchen_id: initialData.kitchen_id || '',
    root_id: initialData.root_id || '',
    note: initialData.note || '',
    price: initialData.price || '',
    image: null,
    printer_id: initialData.printer_id || '',
  });

  // ✅ حالة الصورة الحالية
  const [currentImage, setCurrentImage] = useState(initialData.image || "");

  const [kitchens, setKitchens] = useState([]);
  const [branches, setBranches] = useState([]);
  const [printers, setPrinters] = useState([]); // ✅ حالة الطابعات
  const [message, setMessage] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const loadData = async () => {
      try {
        const [kitchenList, branchList] = await Promise.all([
          fetchKitchens(),
          fetchActiveBranches(),
        ]);
        setKitchens(kitchenList);
        setBranches(branchList);

        // تحميل الطابعات
        const res = await import('../../../../services/Settings/printers');
        const printersList = await res.getPrintersByBranch();
        setPrinters(printersList);

        // ✅ عند فتح النموذج، عيّن الصورة الحالية من البيانات الأولية
        setCurrentImage(initialData.image || "");
      } catch (err) {
        setMessage({ type: 'error', text: '❌ فشل في تحميل الفروع أو المطابخ أو الطابعات' });
      }
    };
    loadData();
  }, [initialData]);

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (name === "image" && files && files[0]) {
      setFormData((prev) => ({
        ...prev,
        image: files[0]
      }));
      // ✅ عرض الصورة الجديدة مباشرة
      setCurrentImage(URL.createObjectURL(files[0]));
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: value
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage(null);

    // تحقق من رفع صورة جديدة أو وجود صورة حالية
    if (!formData.image && !initialData.image) {
      setMessage({ type: 'error', text: 'برجاء اختيار صورة للمجموعة قبل الحفظ' });
      setLoading(false);
      return;
    }

    const submitData = { ...formData };
    if (!formData.image && initialData.image) {
      submitData.image = initialData.image;
    }

    try {
      await updateCategoryGroup(submitData);
      setMessage({ type: 'success', text: '✅ تم تعديل المجموعة بنجاح' });
      if (onSuccess) onSuccess();
    } catch (err) {
      setMessage({ type: 'error', text: err.message });
    } finally {
      setLoading(false);
    }
  };

  const handleCloseSnackbar = () => setMessage(null);

  return (
    <Paper sx={{ p: 3, maxWidth: 600, mx: 'auto' }}>
      <Typography variant="h6" gutterBottom>تعديل بيانات المجموعة</Typography>
      <form onSubmit={handleSubmit} encType="multipart/form-data">
        <TextField
          label="اسم المجموعة"
          name="name"
          value={formData.name}
          onChange={handleChange}
          fullWidth
          required
          margin="normal"
        />

        <FormControl fullWidth margin="normal">
          <InputLabel>اختر المطبخ</InputLabel>
          <Select
            name="kitchen_id"
            value={formData.kitchen_id}
            onChange={handleChange}
            required
          >
            {kitchens.map((kitchen) => (
              <MenuItem key={kitchen.id} value={kitchen.id}>{kitchen.name}</MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl fullWidth margin="normal">
          <InputLabel>اختر الفرع</InputLabel>
          <Select
            name="root_id"
            value={formData.root_id}
            onChange={handleChange}
            required
          >
            {branches.map((branch) => (
              <MenuItem key={branch.id} value={branch.id}>{branch.name}</MenuItem>
            ))}
          </Select>
        </FormControl>

        {/* ✅ حقل اختيار الطابعة */}
        <FormControl fullWidth margin="normal">
          <InputLabel>اختر الطابعة</InputLabel>
          <Select
            name="printer_id"
            value={formData.printer_id}
            onChange={handleChange}
            label="اختر الطابعة"
          >
            <MenuItem value="">بدون طابعة</MenuItem>
            {printers.map((printer) => (
              <MenuItem key={printer.id} value={printer.id}>
                {printer.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <TextField
          label="ملاحظة"
          name="note"
          value={formData.note}
          onChange={handleChange}
          fullWidth
          margin="normal"
        />



        {/* ✅ عرض الصورة الحالية إن وجدت */}
        {initialData.image && (
          <Box mt={2} mb={2} sx={{ textAlign: "center" }}>
            <img
              src={
                typeof initialData.image === "string" && !initialData.image.startsWith("blob:")
                  ? `http://moumen01.restocash.app/${initialData.image}`
                  : initialData.image
              }
              alt="صورة المجموعة"
              style={{ maxWidth: 180, maxHeight: 120, borderRadius: 8, border: "1px solid #eee" }}
            />
            <Typography variant="caption" display="block" sx={{ mt: 1 }}>
              الصورة الحالية من بيانات المجموعة
            </Typography>
          </Box>
        )}

        <Box mt={2}>
          <input
            type="file"
            name="image"
            accept="image/*"
            onChange={handleChange}
          />
        </Box>
        <Typography variant="caption" display="block" sx={{ mt: 1 }}>
برجاء التاكد من اختيار صورة قبل الحفظ            </Typography>

        <Button
          type="submit"
          variant="contained"
          fullWidth
          sx={{ mt: 2 }}
          disabled={loading}
        >
          {loading ? 'جاري التحديث...' : 'تحديث المجموعة'}
        </Button>

      </form>

      {message && (
        <Snackbar open autoHideDuration={4000} onClose={handleCloseSnackbar}>
          <Alert onClose={handleCloseSnackbar} severity={message.type} sx={{ width: '100%' }}>
            {message.text}
          </Alert>
        </Snackbar>
      )}
    </Paper>
  );
};

export default EditCategoryGroupForm;
